module.exports = __webpack_public_path__ + "static/media/image_placeholder.b9fdb5e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MissionShow/MissionPage/PhotoPage/image_placeholder.png
// module id = 1744
// module chunks = 0